module.exports = __webpack_public_path__ + "static/img/taian5.d1f9b803.jpg";